import React from 'react';
import './Loader.css';


const Loader = () => {
  return (
    // <div className="loader1"></div>
    <div id="preloader">
      <div id="status">
        <div className="spinner-chase">
          <div className="chase-dot" />
          <div className="chase-dot" />
          <div className="chase-dot" />
          <div className="chase-dot" />
          <div className="chase-dot" />
          <div className="chase-dot" />
        </div>
      </div>
    </div>

  );
};



export default Loader;
